import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";

export default async function getGeneralReport(
  eventId = '',
  limit = 10,
  offset = 0,
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/report/getGeneralReport?eventId=${eventId}&limit=${limit}&offset=${offset}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error getGeneralReport', error);
    throw error;
  }
}
